import React, { Component } from "react"
import { PropTypes } from "prop-types";
import {MembershipBenefitType} from "../../../Model/MembershipBenefit";
import CommonPulseLoader from "../../../components/widget/progress/CommonPulseLoader";
import MembershipFreeItemService from "./MembershipFreeItemService";

const debugMode = window.debugSetting && window.debugSetting.admin_order.debug_mode
class ApplyMembershipBenefitForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: {

            },
            eligibleOrders: [],
            autoSaveCountdown: "",
        }

        this.saveTimer = null
        this.autoSaveTimer = null

        this.membershipFreeItemService = new MembershipFreeItemService({
            membership: this.props.membership,
            orders: this.props.orders,
            menuItems: this.props.app.state.menuItems,
        })
    }

    componentDidMount() {
        this.calculateEligibleOrderItem()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevState.data.selectedOrderForFreeItem?.order && this.state.data.selectedOrderForFreeItem?.order) {
            console.log(prevState.data.selectedOrderForFreeItem.order.id, this.state.data.selectedOrderForFreeItem.order.id)
            if (prevState.data.selectedOrderForFreeItem.order.id !== this.state.data.selectedOrderForFreeItem.order.id) {
                this.cancelCountdown()
            }
        }
    }

    componentWillUnmount() {
        if (this.saveTimer) {
            clearTimeout(this.saveTimer)
        }
        if (this.autoSaveTimer) {
            clearInterval(this.autoSaveTimer)
        }
    }

    calculateEligibleOrderItem = () => {
        this.setState({
            eligibleOrders: this.membershipFreeItemService.getEligibleOrderItem()
        }, () => {
            if (this.props.autoSelectOnOpen) {
                this.autoChoose()

                if (this.props.autoSaveIn > 0) {
                    this.countDownAutoSave(this.props.autoSaveIn)
                }
            }
        })
    }

    cancelCountdown = () => {
        this.setState({
            autoSaveCountdown: ""
        })
        if (this.autoSaveTimer) {
            clearInterval(this.autoSaveTimer)
        }
    }
    countDownAutoSave = (autoSaveIn) => {
        this.setState({
            autoSaveCountdown: autoSaveIn
        })
        this.autoSaveTimer = setInterval(() => {
            this.setState(({autoSaveCountdown}) => {
                autoSaveCountdown = autoSaveCountdown - 1
                if (autoSaveCountdown < 0) {
                    autoSaveCountdown = 0
                    setTimeout(() => {
                        this.cancelCountdown()
                    }, 0)
                    setTimeout(() => {
                        this.onSubmit()
                    }, 200)
                }
                return {
                    autoSaveCountdown: autoSaveCountdown
                }
            })
        }, 1000)
    }

    onSubmit = () => {
        if (this.state.data.selectedOrderForFreeItem) {
            this.setState({
                isSaving: true
            })

            this.saveTimer = setTimeout(() => {
                this.setState({
                    isSaving: false
                })
            }, 10000)
            this.props.onSubmit(this.state.data.selectedOrderForFreeItem)
        }
    }

    autoChoose = () => {
        let mostExpensiveEligibleOrder = null
        this.state.eligibleOrders.forEach(eligibleOrder => {
            const order = eligibleOrder.order
            if (!mostExpensiveEligibleOrder) {
                mostExpensiveEligibleOrder = eligibleOrder
            }
            else {
                if (parseFloat(mostExpensiveEligibleOrder.order.order_total) < parseFloat(order.order_total)) {
                    mostExpensiveEligibleOrder = eligibleOrder
                }
            }
        })

        this.setState({
            data: {
                ...this.state.data,
                selectedOrderForFreeItem: mostExpensiveEligibleOrder
            }
        })
    }

    selectItem = (eligibleOrder) => {
        this.setState({
            data: {
                ...this.state.data,
                selectedOrderForFreeItem: eligibleOrder
            }
        })
    }

    render() {
        let currency = this.props.app.state.currencyName
        return (
            <div className="ma-4">
                <h3>{lang.apply_membership_benefit}</h3>
                <div>* Free 1 item from below items </div>

                {
                    this.state.eligibleOrders.length ?
                    <ul className="list-group">
                        {
                            this.state.eligibleOrders.map(eligibleOrder => {
                                const order = eligibleOrder.order
                                const isSelected = this.state.data.selectedOrderForFreeItem?.order?.id === order.id
                                return <li className={`list-group-item ${isSelected ? "active" : ""}`} key={order.id} onClick={() => this.selectItem(eligibleOrder)}>
                                    <div style={{display: "flex"}}>
                                        <span
                                            style={{flex: "1 0 10px"}}>{debugMode && `(${order.id}) `} {order.desc}</span>
                                        <span>{currency} {parseFloat(order.order_total).toFixed(2)}</span>
                                    </div>
                                </li>
                            })
                        }
                    </ul> :
                    <div className="text-center mt-3">{lang.no_eligible_order_item}</div>
                }

                <div className="mt-2 text-right">
                    {
                        this.state.isSaving ?
                        <CommonPulseLoader /> :
                        <div style={{display: "flex", gap: "5px", flexDirection: "row-reverse"}}>
                            <button className="btn btn-danger" onClick={this.props.onClose}>{lang.close}</button>
                            <button className="btn btn-primary" onClick={this.onSubmit}
                                    disabled={!this.state.data.selectedOrderForFreeItem}>
                                {lang.save}
                                {
                                    this.state.autoSaveCountdown !== "" &&
                                    <span className="ml-1">({this.state.autoSaveCountdown})</span>
                                }
                            </button>
                            <span style={{flex: "1 0 10px"}}></span>
                            <button className="btn btn-success"
                                    onClick={this.autoChoose}>{lang.auto_select}</button>
                        </div>
                    }
                </div>
            </div>
        )
    }
}


ApplyMembershipBenefitForm.defaultProps = {
    showOnlyActive: true,
    onGoToAdminOrderPage: null,
    autoSelectOnOpen: false,
    autoSaveIn: 0,
}

ApplyMembershipBenefitForm.propTypes = {
    app: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    tableSession: PropTypes.object.isRequired,
    membership: PropTypes.object.isRequired,
    orders: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    autoSelectOnOpen: PropTypes.bool.isRequired,
    autoSaveIn: PropTypes.number.isRequired,
}

export default ApplyMembershipBenefitForm